import { ContentContainer } from 'themes/organic/components/ContentContainer';

import { Heading } from 'components/Heading';

import s from './OrganicAboutSection.module.css';

export interface AboutProps {
  className?: string;
  about: string;
}

export const OrganicAboutSection = ({ about }: AboutProps) => {
  const hasAboutText = about?.length > 0;

  if (!hasAboutText) {
    return null;
  }

  return (
    <section className={s.root}>
      <ContentContainer className={s.content}>
        <Heading as="h1" variant="large">
          About
        </Heading>
        <p className={s.text}>{about}</p>
      </ContentContainer>
    </section>
  );
};
